// extracted by mini-css-extract-plugin
export default {"contact-card":"Card_contact-card__Dps9j","item":"Card_item__PD8S4","icon-box":"Card_icon-box__rimBZ","content":"Card_content__dUk4o"};